import { render, staticRenderFns } from "./aichat.vue?vue&type=template&id=457dd250&scoped=true"
import script from "./aichat.vue?vue&type=script&lang=js"
export * from "./aichat.vue?vue&type=script&lang=js"
import style0 from "./aichat.vue?vue&type=style&index=0&id=457dd250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457dd250",
  null
  
)

export default component.exports